import React from "react";
import { useHistory } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";

const Auth0ProviderWithHistory = ({ children }) => {
    const domain = process.env.REACT_APP_AUTH0_DOMAIN;
    const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
    const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
    let redirectUri = "";
    const history = useHistory();

    if(history.location.pathname === "/"){
        redirectUri = process.env.REACT_APP_CALLBACK_URL;
    // }else if(history.location.pathname === "/a/:idAfinidad/landing"){
    }
    // else if(history.location.pathname.startsWith("/a/")){
    //     redirectUri = process.env.REACT_APP_CUSTOMER_CALLBACK_URL;
    // }

    const onRedirectCallback = (appState) => {
        history.push(appState?.returnTo || window.location.pathname);
    };


    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            redirectUri={redirectUri}
            onRedirectCallback={onRedirectCallback}
            audience={audience}
            cacheLocation="localstorage"
        >
            {children}
        </Auth0Provider>
    );
};

export default Auth0ProviderWithHistory;

